import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { IRules } from 'rev-shared/ui/css/CssRules.Contract';
import { VideoService } from 'rev-shared/media/Video.Service';

import { BrandingSettings } from 'rev-portal/branding/BrandingSettings.Contract';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

import styles from './video-rating.module.less';
@Component({
	selector: 'video-rating',
	templateUrl: './VideoRating.Component.html'
})
export class VideoRatingComponent implements OnInit, OnDestroy {
	@Input() private userId: string;
	@Input() private videoId: string;
	@Input() public isReadOnly: boolean;
	@Input() public rating: number;
	@Input() public ratingCount: number;

	public readonly styles = styles;

	public themeServiceSub: Subscription;
	public themeStyleOverrides: IRules;

	constructor(
		private VideoService: VideoService,
		private ThemeService: ThemeService
	) { }

	public ngOnInit(): void {
		this.themeServiceSub = this.ThemeService.brandingSettings$.subscribe(brandingSettings => this.applyCssRules(brandingSettings));
	}

	public ngOnDestroy(): void {
		this.themeServiceSub?.unsubscribe();
	}

	public applyCssRules(brandingSettings: BrandingSettings): void {
		const themeAccentColor = brandingSettings.themeSettings.accentColor;
		this.themeStyleOverrides = {
			['.bs-rating-star.active']: {
				'color': `${themeAccentColor} !important`
			}
		};
	}

	public onRatingClick(): void {
		if(this.isReadOnly) {
			return;
		}
		this.VideoService.rateVideo({
			videoId: this.videoId,
			rating: this.rating
		});
	}
}
